export {GaussianNB} from './GaussianNB';
export {MultinomialNB} from './MultinomialNB';



// WEBPACK FOOTER //
// ./node_modules/ml-naivebayes/src/index.js